module.exports = __webpack_public_path__ + "static/media/my-profile.25aef866.svg";